<div>
  <syn-header label="Project Migration Service">
    <nav slot="meta-navigation">
      <syn-icon-button color="neutral" name="logout" label="Logout" (click)="logout()" (keyup)="onKeyUp($event)"></syn-icon-button>
    </nav>
  </syn-header>

  <div class="main_component_container">
    <router-outlet></router-outlet>
  </div>
</div>
